/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { Modal } from "antd";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import { StatusInfo } from "../../../utility/status_info_modal";
export default function SubAckJob({
  CompanyId,
  OperatorId,
  ProjectId,
  ModalShow,
  setModalShow,
  workflowJob,
  jobDetail,
  so_id,
}) {
  const [statusSubmit, setstatusSubmit] = useState(false);
  const [Spin, setSpin] = useState(true);
  const [showText, setshowText] = useState("Loading..");
  const [statusInfoMode, setstatusInfoMode] = useState("success");
  async function SendDataAckjob() {
    setshowText("Sending Ack Job");
    setstatusSubmit(true);
    workflowJob.map((data, index) => {
      if (data.from_main_process_id === 2 && data.next_main_action_id === 17) {
        const sendDataSent = {
          ...workflowJob[index],
          company_id: CompanyId,
          operator_id: OperatorId,
          project_id: ProjectId,
          job_id: jobDetail.job_id,
          job_progress_id: jobDetail.job_progress_id,
          location_lat: "",
          location_long: "",
          create_by: Cookies.get("username"),
          acknowledge_status: "Y",
          progress_Status_flag: "",
          jobtypeid: jobDetail.job_type_id,
        };
        Api.post("tabUpdateAckJobBold", sendDataSent)
          .then((res) => {
            if (res.data.result.code === "P") {
              setshowText("Ack Job Success");
              setSpin(false);
            } else if (res.data.result.code === "F") {
              setshowText(`Error :  ${res.data.result?.showText}`);
              setSpin(false);
              setstatusInfoMode("error");
            }
          })
          .catch((e) => {
            setshowText(`Error :  ${e}`);
            setSpin(false);
            setstatusInfoMode("error");
          });
      }
    });
    if (workflowJob?.length === 0) {
      setshowText(`Error :  You can't access this function`);
      setSpin(false);
      setstatusInfoMode("error");
    }
  }
  const statusInfoCallBack = () => {
    setstatusSubmit(false);
    setModalShow(false);
    if (statusInfoMode !== "error") {
      window.location.reload();
    }
  };
  return (
    <Modal
      title={null}
      centered
      visible={ModalShow}
      footer={null}
      closable={false}
    >
      {statusSubmit ? (
        <StatusInfo
          callbackFunction={statusInfoCallBack}
          showSpinIcon={Spin}
          statusText={showText}
          mode={statusInfoMode}
        ></StatusInfo>
      ) : (
        <div className="text-center">
          <div className="row d-flex justify-content-center">
            <img
              src={Api.absoluteUrl("/img/Checking_boxes_rafiki.svg")}
              className="img-fluid"
            />
          </div>
          <div className="row d-flex justify-content-center">
            <span className="font-thai-b fs-22 c-blue">
              {`ยืนยันการรับงาน : ${jobDetail.job_no} / ${
                jobDetail.so_id ? jobDetail.so_id : so_id ? so_id : null
              }`}
            </span>
          </div>
          <div className="row d-flex justify-content-center mt-2">
            <button
              className="btn btn-secondary"
              onClick={() => setModalShow(false)}
            >
              Close
            </button>
            {statusSubmit ? (
              <button className="btn btn-success" disabled>
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </button>
            ) : (
              <button
                className="btn btn-success"
                onClick={() => SendDataAckjob()}
              >
                Confirm
              </button>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
}
